import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useProperty, useSiteContext } from '@eti/providers';
import { css } from '@eti/styles';
import { BoundNew } from '@eti/types';
import { date } from '@eti/utils';

const hotelsWrapperStyles = css`
  max-width: 960px;
`;

const nrTravelersWithAgeType = (travelers, ageType) =>
  travelers.filter((t) => t.ageType === ageType).length;

const HotelsComWidget = ({ bounds, obfuscatedOrderNumber, purchaseDate, travelers }) => {
  const { p } = useProperty();
  const {
    language: { code: locale },
    siteCurrency: { code: currency },
  } = useSiteContext();

  useEffect(() => {
    const outbound = bounds[0];
    const outboundDate = date.format(
      outbound.segments[outbound.segments.length - 1].arrivedAt,
      'yyyy-MM-dd',
    );
    const inboundDate = date.format(
      bounds[bounds.length - 1].segments[0].departuredAt,
      'yyyy-MM-dd',
    );
    const airportDeparture = outbound.segments[0].origin.code;
    const airportArrival = outbound.segments[outbound.segments.length - 1].destination.code;
    const nrOfAdults = nrTravelersWithAgeType(travelers, 'ADT');
    const nrOfChildren = nrTravelersWithAgeType(travelers, 'CNN');
    const nrOfInfants = nrTravelersWithAgeType(travelers, 'INF');
    const flightClass = outbound.segments[0].cabinClassName.toLowerCase();

    window.xSell = {
      widgetTarget: 'upsell-hotels-com-widget',
      outboundDate,
      inboundDate,
      airportDeparture,
      airportArrival,
      nrOfAdults,
      nrOfChildren: nrOfChildren + nrOfInfants,
      locale,
      currency,
      pnr: obfuscatedOrderNumber,
      flightClass,
      purchaseDate,
      widgetType: 'CP',
      widgetID: p('IbeClient.Order.UpsellHotelsCom.WidgetId'),
      gaLinkerParameter: p('IbeClient.Order.UpsellHotelsCom.GaLinkerParameter'),
      partnerLoyaltyNumber: 0,
    };

    const xSellScript = document.createElement('script');
    xSellScript.setAttribute('src', 'https://widgets.hotels.com/xsell.js');
    xSellScript.setAttribute('data-testid', 'upsell-hotels-com-script');
    document.body.appendChild(xSellScript);
  }, [bounds, currency, locale, obfuscatedOrderNumber, p, purchaseDate, travelers]);

  return (
    <div
      className={hotelsWrapperStyles}
      data-testid="upsell-hotels-com-widget"
      id="upsell-hotels-com-widget"
    />
  );
};

HotelsComWidget.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
  obfuscatedOrderNumber: PropTypes.string,
  purchaseDate: PropTypes.string,
  travelers: PropTypes.arrayOf(
    PropTypes.shape({
      ageType: PropTypes.string,
      birthDate: PropTypes.string,
      firstName: PropTypes.string,
      gender: PropTypes.string,
      id: PropTypes.string,
      lastName: PropTypes.string,
      name: PropTypes.string,
      passportNumber: PropTypes.string,
      products: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          quantity: PropTypes.number,
        }),
      ),
    }),
  ),
};

export default HotelsComWidget;
